import { render, staticRenderFns } from "./Config2Software.vue?vue&type=template&id=5274ba6a&scoped=true"
import script from "./Config2Software.vue?vue&type=script&lang=js"
export * from "./Config2Software.vue?vue&type=script&lang=js"
import style0 from "./Config2Software.vue?vue&type=style&index=0&id=5274ba6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5274ba6a",
  null
  
)

export default component.exports